module.exports = __webpack_public_path__ + "img/variables.7b7f412b.svg";